import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const templates = [
  {
    id: 'modern',
    name: 'Modern',
    description: 'Clean and contemporary design',
    preview: 'bg-gradient-to-br from-blue-50 to-indigo-50'
  },
  {
    id: 'professional',
    name: 'Professional',
    description: 'Traditional corporate style',
    preview: 'bg-gradient-to-br from-gray-50 to-slate-100'
  },
  {
    id: 'creative',
    name: 'Creative',
    description: 'Bold and eye-catching',
    preview: 'bg-gradient-to-br from-purple-50 to-pink-50'
  },
  {
    id: 'minimal',
    name: 'Minimal',
    description: 'Simple and elegant',
    preview: 'bg-gradient-to-br from-slate-50 to-gray-50'
  }
];

const TemplateSelector = ({ selectedTemplate, onSelectTemplate }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {templates.map((template) => (
        <motion.button
          key={template.id}
          onClick={() => onSelectTemplate(template.id)}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className={`relative p-3 sm:p-4 rounded-xl border-2 transition-all duration-200 text-left ${
            selectedTemplate === template.id
              ? 'border-blue-600 shadow-lg'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <div className={`h-28 sm:h-32 rounded-lg mb-3 ${template.preview} flex items-center justify-center`}>
            <div className="w-14 h-16 sm:w-16 sm:h-20 bg-white rounded shadow-sm"></div>
          </div>
          <p className="font-semibold text-gray-900 text-sm sm:text-base">{template.name}</p>
          <p className="text-xs sm:text-sm text-gray-500 mt-1">{template.description}</p>
          
          {selectedTemplate === template.id && (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              className="absolute top-2 right-2 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center"
            >
              <Check className="w-4 h-4 text-white" />
            </motion.div>
          )}
        </motion.button>
      ))}
    </div>
  );
};

export default TemplateSelector;